import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getWarehouses({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query {
      warehouses {
        id
        name
        official_name
        code
        federal_tax_payer_id
        state_tax_payer_id
        address {
          street
          number
          additional
          reference
          quarter
          zip_code
          city
          state
          state_code
          country
        }
      }
    }`)
      .then((res) => {
        const { data = {} } = res || {};
        const { warehouses = [] } = data || {};
        commit('toggleLoading', false);
        commit('setWarehouses', warehouses);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};


// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-reverse/store/warehouses/actions.js